import React from 'react';
import {
  Form,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';
import './CancelTicket.scss';
import { initialValues, validationSchema } from './constants';

function CancelTicket({ isOpen, toggle, handleOnSubmit, isLoading }) {
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });

  const onSubmit = async values => {
    const payload = {
      cancelReason: values.reason,
    };
    await handleOnSubmit(payload);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xs">
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="d-flex flex-column gap-3"
      >
        <ModalBody>
          <div>
            <h5>Confirmation</h5>
            <p>Are you sure you want to cancel this ticket?</p>
          </div>
          <Label>
            Reason<span className="text-danger">*</span>
          </Label>
          <Controller
            control={control}
            name="reason"
            render={({ field }) => (
              <Input
                {...field}
                type="textarea"
                className={`form-control ${errors.reason ? 'is-invalid' : ''}`}
                placeholder="Enter Reason"
                rows="4"
              />
            )}
          />
          {errors.reason && (
            <div className="invalid-feedback">{errors.reason.message}</div>
          )}
        </ModalBody>
        <ModalFooter>
          <Col>
            <Button
              type="button"
              onClick={toggle}
              className="w-100 custom-light-btn"
            >
              No
            </Button>
          </Col>
          <Col>
            <Button
              onClick={handleSubmit(onSubmit)}
              type="button"
              className="w-100 custom-btn"
              disabled={!isValid || isLoading}
            >
              {isLoading ? 'Cancelling...' : 'Yes, Cancel'}
            </Button>
          </Col>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default CancelTicket;
